import ArrowDownIcon from './../../assets/img/icons/arrow-down.svg';
import ArrowLeftSmallIcon from './../../assets/img/icons/arrow-left-small.svg';
import ArrowRightSmallIcon from './../../assets/img/icons/arrow-right-small.svg';
import BookeroLogo from './../../assets/img/bookero-logo.svg';
import CalendarBigIcon from './../../assets/img/icons/calendar-big.svg';
import CalendarBigColorIcon from './../../assets/img/icons/calendar-big-color.svg';
import CalendarDotsIcon from './../../assets/img/icons/calendar-dots.svg';
import CalendarDateIcon from './../../assets/img/icons/calendar-date.svg';
import CalendarThinIcon from './../../assets/img/icons/calendar-thin.svg';
import CartIcon from './../../assets/img/icons/cart.svg';
import ChartIcon from './../../assets/img/icons/chart.svg';
import ChartBigIcon from './../../assets/img/icons/chart-big.svg';
import CheckCircleIcon from './../../assets/img/icons/check-circle.svg';
import CheckCircleBigIcon from './../../assets/img/icons/check-circle-big.svg';
import CogIcon from './../../assets/img/icons/cog.svg';
import CrossIcon from './../../assets/img/icons/cross.svg';
import CrossCircleIcon from './../../assets/img/icons/cross-circle.svg';
import DownloadIcon from './../../assets/img/icons/download.svg';
import EditIcon from './../../assets/img/icons/edit.svg';
import EditCircleIcon from './../../assets/img/icons/edit-circle.svg';
import ExclamationIcon from './../../assets/img/icons/exclamation.svg';
import FolderIcon from './../../assets/img/icons/folder.svg';
import FoldIcon from './../../assets/img/icons/fold.svg';
import GridIcon from './../../assets/img/icons/grid.svg';
import HamburgerMenuIcon from './../../assets/img/icons/hamburger-menu.svg';
import HorizontalLinesPlusIcon from './../../assets/img/icons/horizontal-lines-plus.svg';
import HomeIcon from './../../assets/img/icons/home.svg';
import InfoCircleIcon from './../../assets/img/icons/info-circle.svg';
import InfoCircleAltIcon from './../../assets/img/icons/info-circle-alt.svg';
import LayersBigColorIcon from './../../assets/img/icons/layers-big-color.svg';
import LayersBoldIcon from './../../assets/img/icons/layers-bold.svg';
import LayersThinIcon from './../../assets/img/icons/layers-thin.svg';
import ListIcon from './../../assets/img/icons/list.svg';
import LoaderIcon from './../../assets/img/icons/loader.svg';
import LockIcon from './../../assets/img/icons/lock.svg';
import MailBigColorIcon from './../../assets/img/icons/mail-big-color.svg';
import MailBoxIcon from './../../assets/img/icons/mailbox.svg';
import MailBoxCircleIcon from './../../assets/img/icons/mailbox-circle.svg';
import MenuIcon from './../../assets/img/icons/menu.svg';
import MenuNoFillIcon from './../../assets/img/icons/menu-no-fill.svg';
import NetworkIcon from './../../assets/img/icons/network.svg';
import OkIcon from './../../assets/img/icons/ok.svg';
import OkCircleIcon from './../../assets/img/icons/ok-circle.svg';
import PaperClipIcon from './../../assets/img/icons/paperclip.svg';
import PassIcon from './../../assets/img/icons/pass.svg';
import PauseIcon from './../../assets/img/icons/pause.svg';
import PhoneIcon from './../../assets/img/icons/phone.svg';
import PlusIcon from './../../assets/img/icons/plus.svg';
import PlusCircleIcon from './../../assets/img/icons/plus-circle.svg';
import PreviewIcon from './../../assets/img/icons/preview.svg';
import ProfileIcon from './../../assets/img/icons/profile.svg';
import ProfileBigIcon from './../../assets/img/icons/profile-big.svg';
import ProfileFillIcon from './../../assets/img/icons/profile-fill.svg';
import RingBellIcon from './../../assets/img/icons/ring-bell.svg';
import RodoBigColorIcon from './../../assets/img/icons/rodo-big-color.svg';
import SearchIcon from './../../assets/img/icons/search.svg';
import SuitcaseIcon from './../../assets/img/icons/suitcase.svg';
import SwitchesIcon from './../../assets/img/icons/switches.svg';
import ThumbsDownIcon from './../../assets/img/icons/thumbs-down.svg';
import ThumbsDownCircleIcon from './../../assets/img/icons/thumbs-down-circle.svg';
import ThumbsUpCircleIcon from './../../assets/img/icons/thumbs-up-circle.svg';
import TimeIcon from './../../assets/img/icons/time.svg';
import TrashIcon from './../../assets/img/icons/trash.svg';
import TriggerIcon from './../../assets/img/icons/trigger.svg';
import TriggerBigIcon from './../../assets/img/icons/trigger-big.svg';
import VerticalLinesPlusIcon from './../../assets/img/icons/vertical-lines-plus.svg';
import QuestionCircleIcon from './../../assets/img/icons/question-circle.svg';
import QuestionnaireIcon from './../../assets/img/icons/questionnaire.svg';
import QuestionnaireFilledIcon from './../../assets/img/icons/questionnaire-filled.svg';

// Notification icons
import NotificationAcceptedInquiryIcon from './../../assets/img/icons/notification-accepted-inquiry.svg';
import NotificationCancelledInquiryIcon from './../../assets/img/icons/notification-cancelled-inquiry.svg';
import NotificationChangeTerminInquiryIcon from './../../assets/img/icons/notification-change-termin.svg';
import NotificationInquiryNotPaidIcon from './../../assets/img/icons/notification-inquiry-not-paid.svg';
import NotificationInquiryPaidIcon from './../../assets/img/icons/notification-inquiry-paid.svg';
import NotificationNewFeatureIcon from './../../assets/img/icons/notification-new-feature.svg';
import NotificationNewInquiryIcon from './../../assets/img/icons/notification-new-inquiry.svg';
import NotificationNewToPayIcon from './../../assets/img/icons/notification-new-to-pay.svg';
import NotificationReserveListIcon from './../../assets/img/icons/notification-reserve-list.svg';
import NotificationSystemBreakIcon from './../../assets/img/icons/notification-system-break.svg';
import NotificationWarningIcon from './../../assets/img/icons/notification-warning.svg';

// Flags
import CzIcon from './../../assets/img/flags/cz.svg';
import DeIcon from './../../assets/img/flags/de.svg';
import EnIcon from './../../assets/img/flags/en.svg';
import HuIcon from './../../assets/img/flags/hu.svg';
import ItIcon from './../../assets/img/flags/it.svg';
import PlIcon from './../../assets/img/flags/pl.svg';
import RoIcon from './../../assets/img/flags/ro.svg';
import RuIcon from './../../assets/img/flags/ru.svg';
import SkIcon from './../../assets/img/flags/sk.svg';
import UaIcon from './../../assets/img/flags/ua.svg';

export default {
  ArrowDownIcon,
  ArrowLeftSmallIcon,
  ArrowRightSmallIcon,
  BookeroLogo,
  CalendarBigIcon,
  CalendarBigColorIcon,
  CalendarDotsIcon,
  CalendarDateIcon,
  CalendarThinIcon,
  CartIcon,
  ChartIcon,
  ChartBigIcon,
  CheckCircleIcon,
  CheckCircleBigIcon,
  CogIcon,
  CrossIcon,
  CrossCircleIcon,
  DownloadIcon,
  EditIcon,
  EditCircleIcon,
  ExclamationIcon,
  FolderIcon,
  FoldIcon,
  GridIcon,
  HamburgerMenuIcon,
  HomeIcon,
  HorizontalLinesPlusIcon,
  InfoCircleIcon,
  InfoCircleAltIcon,
  LayersBigColorIcon,
  LayersBoldIcon,
  LayersThinIcon,
  ListIcon,
  LoaderIcon,
  LockIcon,
  MailBigColorIcon,
  MailBoxIcon,
  MailBoxCircleIcon,
  MenuIcon,
  MenuNoFillIcon,
  NetworkIcon,
  OkIcon,
  OkCircleIcon,
  PaperClipIcon,
  PassIcon,
  PauseIcon,
  PhoneIcon,
  PlusIcon,
  PlusCircleIcon,
  PreviewIcon,
  ProfileIcon,
  ProfileBigIcon,
  ProfileFillIcon,
  RingBellIcon,
  RodoBigColorIcon,
  SearchIcon,
  SuitcaseIcon,
  SwitchesIcon,
  ThumbsDownIcon,
  ThumbsDownCircleIcon,
  ThumbsUpCircleIcon,
  TimeIcon,
  TrashIcon,
  TriggerIcon,
  TriggerBigIcon,
  VerticalLinesPlusIcon,
  QuestionCircleIcon,
  QuestionnaireIcon,
  QuestionnaireFilledIcon,
  // notifications
  NotificationAcceptedInquiryIcon,
  NotificationCancelledInquiryIcon,
  NotificationChangeTerminInquiryIcon,
  NotificationInquiryNotPaidIcon,
  NotificationInquiryPaidIcon,
  NotificationNewFeatureIcon,
  NotificationNewInquiryIcon,
  NotificationNewToPayIcon,
  NotificationReserveListIcon,
  NotificationSystemBreakIcon,
  NotificationWarningIcon,
  // flags
  CzIcon,
  DeIcon,
  EnIcon,
  HuIcon,
  ItIcon,
  PlIcon,
  RoIcon,
  RuIcon,
  SkIcon,
  UaIcon,
  loaded () {
  }
};



// WEBPACK FOOTER //
// ./src/components/helpers/IconLoader.js